<template>
<div>



<alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
<form id="formMain" v-on:submit.prevent="submit()" >
    <div class="form-row">
    <div class="form-group col-md-4">
    <label for="doc_type"><strong>Tipo documento</strong></label>
    <select required v-model="packing.typeId" class="form-control" id="doc_type">
    
                <option value="2">DDT</option>
                </select>
                </div>
                <div class="form-group col-md-4">
                  <label for="number_doc"><strong>Numero documento</strong></label>
                  <input v-focus v-model="packing.number" type="text" class="form-control " placeholder="" name="number_doc" id = "number_doc" required>
                  
                 <!-- <last-packing-slip @update="setPackingNumber" :key="refresh"></last-packing-slip>-->
                  
                </div>
                <div class="form-group col-md-4">
                  <label for="date_doc"><strong>Data documento</strong></label>
                  <input required v-model="packing.date" type="date" class="form-control" placeholder="" name="date_doc" id = "date_doc">
                  
                </div>
                </div>
                <div class="form-row">
                <div class="form-group  col-md-6">
                  <label for="number_doc"><strong>Numero colli</strong></label>
                  <input v-model="packing.total_packages" type="number" class="form-control " placeholder=""  required>
                </div>
                <div class="form-group  col-md-6">
                  <label for="doc_appearance"><strong>Aspetto beni</strong></label>
                  <input v-model="packing.appearance" type="text" class="form-control " placeholder=""  required>
                </div>
                </div>
                <div class="form-group">
                  <label for="number_doc"><strong>Destinazione</strong></label>
                  <input v-model="packing.destination" type="text" class="form-control" placeholder=""  required>
                </div>
                <div class="form-group">
                  <label for="doc_reference"><strong>Riferimento</strong></label>
                  <input v-model="packing.reference" type="text" class="form-control" placeholder=""  required>
                </div>

                 <shipper-select v-bind:props="shipper"  @update="setShipperId" :key="refresh"></shipper-select>

                  

                  <div v-if="headings.length>1" >
                  
                  <label  for="heading"><strong>INTESTAZIONE DDT</strong></label>  
                  <select  class="form-control mb-3" v-model="rowId">                        
                    <option v-for="(item,index) in headings" :value="item.rowId" :key="index">
                    {{item.heading1}}</option>                            
                  </select> 

                  </div>
                  
                  


                  <div class="form-group float-right">                                    
                  <div class="form-check ">
                    <input class="form-check-input" type="checkbox" id="gridCheck2" v-model="packing.shipping_date">
                    <label class="form-check-label" for="gridCheck2">
                      <strong>Stampa data e ora</strong>
                    </label>
                  </div>
                  
                  <button type="submit"  class="btn btn-success mt-3" >
                    <i class="fas fa-print mr-2" aria-hidden="true"></i>
                    SALVA E STAMPA
                    <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>

          

                  </div>
                 
   
                  <button  @click="$emit('close')" type="button"   class="btn btn-secondary float-left">
                    <i class="fas fa-reply mr-2" aria-hidden="true"></i>
                    ANNULLA
   
                  </button>                

  
 
      </form>





</div>
</template>
<script>


import api              from '@/api';
import alertBox         from '@/components/common/AlertBox.vue';
import shipperSelect    from '@/components/common/ShipperSelect.vue';
//import LastPackingSlip  from '@/components//shipping/LastPackingSlipNumber.vue';

import { mapGetters }   from 'vuex';



export default {
  
  components: {alertBox,shipperSelect
  
  
  },  
  props: ['params'],
 
 data () {
    return {
      

      shipper        : 
      {
        Id            : 9,
        isActive      : true,
       
        //optionBase    : true,
        required      : true
      },
      

      packing         : {typeId:2,reference:'Trasferimento articoli tra sedi',total_packages:0,destination:'LA STESSA',appearance:'SCATOLE',date:new Date().toISOString().slice(0, 10),shipperId:9,update:0,number:0},
      
      alert           : false,
      spinner         : false,
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      },
      refresh         : 0,
      headings        : [],
      rowId           : 0,

      last_packing    : {}
      
      

    }
  },

computed: 
  {

    ...mapGetters(['storeId','company']) , 


  },
   directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
mounted()
{   
    
   
},
created()
{ 
  
    
  this.getData()
},

methods: 
{
    setPackingNumber(n)
    {
      
      this.packing.number = n
      
      
    },
    setShipperId(Id,e)
    {
      
      this.packing.shipperId = Id

     
      
    },
    async getData()
    {
        const storeId = this.params.storeId
        this.msg.title = ''
        const data = {'movementId':this.params.movementId,'companyId':this.company.Id,'storeId' : storeId}

        const sp   = {'sp'         : 'spPackingSlip'}
        const json = Object.assign(data, sp);
       
        this.spinner = true
        await api.post(json).then(res => {
                   
          if(res.status == 200)
            {
              
              if(res.data.recordsets[2].length > 0)
              {
                this.packing.number = res.data.recordsets[2][0].number
              }
              
              this.headings = res.data.recordsets[1]
            

              if(this.headings.length> 0)
              {
                this.rowId = res.data.recordsets[1][0].rowId
              }
              
              if(res.data.recordsets[0].length > 0 )
              {
                
                
                this.packing        = res.data.recordsets[0][0]  
                this.packing.update = 1
                this.shipper.Id     = this.packing.shipperId
                
                
                this.refresh++
                                               

              }
             

            }
           else if(res.status == 500)
           {
                                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
                    
           } 
           else
            {
                             
              this.msg.title =  'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
                 
            } 
          
          }).catch(err => {
                           
              this.msg.title =  'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
              
          }).finally(() => {
              this.spinner = false
        });


	},

  
  async submit() 
  {
    
    
    this.spinner = true
    const storeId = this.params.storeId
    

    const data  = {'documentId':0,'number':this.packing.number,'date':this.packing.date,'typeId':2,'movementId':this.params.movementId,'isSupplier':0,'companyId':this.company.Id,'storeId' : storeId,'update':this.packing.update,'rowId':this.packing.rowId}       
    const sp    = {'sp':'spCreatePackingSlip'}
    const json  = Object.assign(data, sp,this.packing);
    
    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
             
  
              if(res.data.recordsets[0][0].rowId == 0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'Numero DDT già assegnato.'
                this.msg.type = 1                
                
                return
              }

             this.packing.update = 1 
             this.packing.rowId = res.data.recordsets[0][0].rowId
             this.$emit('printPDF',this.packing.shipping_date)

             
             

            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	},

}
}    
</script>

<style scoped>

 
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.form-check-label
{
  cursor: pointer;
}
</style>